import React from 'react';
import Header from "Components/Layouts/Fragrance/Header";

export default class Unauthenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {children, title} = this.props;

        return (
            <div className="min-h-screen bg-blobs bg-cover bg-no-repeat">
                <Header />

                <div className="h-full flex flex-col px-8 py-10  font-light w-full max-w-3xl mx-auto pb-6 lg:pb-16 text-center ">
                    <div>
                        {children}
                    </div>

                    <div className="text-black pt-8">
                        <a href="https://www.boots.com/floating-editorial/editorial-legal/privacypolicy" target="_blank">
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </div>
        )
    };
}
